import React from "react";

const Footer: React.FC = () => (
  <footer className="bg-gray-100 text-center py-4 mt-8">
    <p className="text-gray-500">&copy; {new Date().getFullYear()} RoomRounds. All rights reserved.</p>
  </footer>
);

export default Footer; 